export default function Styles(){
    return(
        <style>
        {`
            .montreal-head-title{
                font-size: 32px !important;
                color: #1B1B1B;
                font-family: 'Fjalla One';
                line-height: 1.25;
                font-weight: 400;
            
                
            }
            .montreal-head-para{
                font-size: 22px;
                color: #5E5E5E;
                font-family:'Josefin Sans';
                line-height: 1.5;
                font-weight: 400;
            }
            
            
            
            
            
            /* // responsive
            
            // @media screen and (min-width:1536px) {
            //     font-size: 44px;
            // } */
            @media screen and (min-width:1280px) {
                .montreal-head-title{
                    font-size: 44px !important;
                }
                .montreal-head-para{
                    font-size: 24px;
                }
                
            }
            @media screen and (min-width:1024px ) and (max-width:1280px) {
                .montreal-head-title{
                    font-size: 38px !important;
                }
            }
            @media screen and (min-width:768px) and (max-width:1024px) {
                .montreal-head-title{
                    font-size: 38px !important;
                }
            }
            @media screen and (min-width:640px) {
                
            }
            
            
            `}
        </style>
    );
}

